// extracted by mini-css-extract-plugin
export default {"bubblearea":"Bubbles_bubblearea__4Kbyo","bubble":"Bubbles_bubble__G3vAF","movebubbles":"Bubbles_movebubbles__zmn2c","sideWays":"Bubbles_sideWays__mvW8w"};